import { Component, HostListener, OnInit } from '@angular/core';
import { MaxBrainAudience } from 'app/library/audience/models/audience.model';
import { AudienceService } from 'app/library/audience/services/audience.service';
import { MaxBrainWidget } from 'app/library/widgets/models/widget.model';
import { WidgetService } from 'app/library/widgets/services/widget.service';
import { filter, take } from 'rxjs/operators';
import { SidenavService } from '../services/sidenav.service';

@Component({
    selector: 'app-grow-start',
    templateUrl: './grow-start.component.html',
    styleUrls: ['./grow-start.component.scss'],
})
export class GrowStartComponent implements OnInit {
    audiences: MaxBrainAudience[] = [];
    widgets: MaxBrainWidget[] = [];

    engageCards: any = [
        {
            title: 'ENGAGE.POSTING.TITLE.PLURAL',
            text: 'ENGAGE.POSTING.DESCRIPTION',
            link: 'ENGAGE.POSTING.ACTION',
            cls: 'posting',
            url: '',
            icon: 'engage_posting',
        },
        {
            title: 'ENGAGE.ARTICLE.TITLE.PLURAL',
            text: 'ENGAGE.ARTICLE.DESCRIPTION',
            link: 'ENGAGE.ARTICLE.ACTION',
            cls: 'article',
            url: '/admin/grow/articles/all',
            icon: 'engage_article',
        },
        {
            title: 'ENGAGE.AUDIENCE.TITLE.PLURAL',
            text: 'ENGAGE.AUDIENCE.DESCRIPTION',
            link: 'ENGAGE.AUDIENCE.ACTION',
            cls: 'audience',
            btn: 'New Audience',
            url: '',
            icon: 'engage_audience',
        },
        {
            title: 'ENGAGE.EXPERIENCE.TITLE.PLURAL',
            text: 'ENGAGE.EXPERIENCE.DESCRIPTION',
            link: 'ENGAGE.EXPERIENCE.ACTION',
            cls: 'experience',
            url: '/admin/grow/experience',
            icon: 'engage_experience',
        },
        {
            title: 'ENGAGE.DEFAULT_SETTING.TITLE',
            text: 'ENGAGE.DEFAULT_SETTING.DESCRIPTION',
            link: 'ENGAGE.DEFAULT_SETTING.ACTION',
            cls: 'default',
            url: '/admin/grow/default',
            icon: 'engage_default',
        },
    ];

    screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    @HostListener('window:resize')
    onResize() {
        this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    constructor(private _audienceService: AudienceService, public sidenavService: SidenavService, private _widgetService: WidgetService) {}

    async ngOnInit(): Promise<void> {
        this.engageCards[0].url = '/admin/grow/postings/all';

        this._audienceService.audiences$
            .pipe(
                filter((x) => !!x),
                take(1)
            )
            .subscribe((audiences) => {
                const defaultAudienceId = audiences.find((audience) => !audience.parent).id;
                this.engageCards[2].url = '/admin/grow/audiences/' + defaultAudienceId;
            });

        this.audiences = this._audienceService.getAudiences() || [];
        if (!this.audiences.length) {
            await this._audienceService.fetchAudiences();
            this.audiences = this._audienceService.getAudiences();
        }

        this._widgetService.fetchWidgets();

        this._widgetService.widget$
            .pipe(
                filter((x) => !!x),
                take(1)
            )
            .subscribe((widgets) => {
                this.widgets = widgets;
            });
    }
}
